export const QUESTIONS = 'QUESTIONS';
export const QUIZZES = 'QUIZZES';
export const TYPE = 'TYPE';
export const ANSWERS = 'ANSWERS';
export const TASK_TRANSLATIONS = 'TASK_TRANSLATIONS';
export const TASK_TRANSLATION_ID = 'TASK_TRANSLATION_ID';
export const HINT_TRANSLATIONS = 'HINT_TRANSLATIONS';
export const HINT_TRANSLATION_ID = 'HINT_TRANSLATION_ID';
export const PICTURES = 'PICTURES';



// WEBPACK FOOTER //
// ./src/store/modules/question/mutation-types.js